export const TABS = {
  APPOINTMENTS: 'APPOINTMENTS',
  SCHEDULES: 'SCHEDULES',
}
